import React from 'react'
// import { getAge } from '../../config/constants'
// import moment from 'moment'

const PlayerInfoBottom = ({ player = {} }) => {
  let infoData = [
    {
      title: 'Team',
      value: player?.Team || '-',
    },
    {
      title: 'Opponent',
      value: player?.Opponent || '-',
    },
    {
      title: 'Postion',
      value: player?.Position || '-',
    },
    {
      title: 'Height',
      value: player?.Height || '-',
    },
    {
      title: 'Years in League',
      value: player?.Experience
        ? player?.Experience <= 1
          ? `${player?.Experience} Year`
          : `${player?.Experience} Years`
        : '-',
    },
    {
      title: 'Player Caps',
      value: player.PlayerCap ? `$${player.PlayerCap?.toLocaleString()}` : '-',
    },
    {
      title: 'Player College',
      value: player?.College || '-',
    },
    {
      title: 'Age',
      value: player?.age ? player?.age : '-',
    },
    {
      title: 'Games Played',
      value: player?.gamesPlayed ? player?.gamesPlayed : '-',
    },
  ]
  return (
    <>
      <div className='info-card-new'>
        {infoData.map((item, index) => (
          <h3 key={index}>
            {item.title} : <span>{item.value}</span>
          </h3>
        ))}
      </div>

      <hr className='divider-new' />

      <div className='player_caps_box_new'>
        <h1>
          Player Cap Hit: {player?.PlayerCap ? `$${player?.PlayerCap?.toLocaleString()}` : '-'}
        </h1>
      </div>
    </>
  )
}

export default PlayerInfoBottom
